export var IdButtonPointer;
(function (IdButtonPointer) {
    /**
     * Main button pressed, usually the left button or the un-initialized state
     */
    IdButtonPointer[IdButtonPointer["Main"] = 0] = "Main";
    /**
     * Auxiliary button pressed, usually the wheel button or the middle button (if present)
     */
    IdButtonPointer[IdButtonPointer["Auxilary"] = 1] = "Auxilary";
    /**
     * Secondary button pressed, usually the right button
     */
    IdButtonPointer[IdButtonPointer["Secondary"] = 2] = "Secondary";
    /**
     * Fourth button, typically the Browser Back button
     */
    IdButtonPointer[IdButtonPointer["Fourth"] = 3] = "Fourth";
    /**
     * Fifth button, typically the Browser Forward button
     */
    IdButtonPointer[IdButtonPointer["Fifth"] = 4] = "Fifth";
})(IdButtonPointer || (IdButtonPointer = {}));



//////////////////
// WEBPACK FOOTER
// ./src/events/IdButtonPointer.ts
// module id = 1665
// module chunks = 3